export default {

  // 出入库
  // 新增客户出入库
  insertYgnInoutRecord: '/ygsjzs/ygnInoutRecord/insertYgnInoutRecord',
  // 修改客户出入库
  updateYgnInoutRecord: '/ygsjzs/ygnInoutRecord/updateYgnInoutRecord',
  // 审批客户出入库
  approveYgnInoutRecord: '/ygsjzs/ygnInoutRecord/approveYgnInoutRecord',
  // 物理删除客户出入库
  deleteDataYgnInoutRecord: '/ygsjzs/ygnInoutRecord/deleteDataYgnInoutRecord',

  // 查询客户出入库详情
  selectYgnInoutRecordByInventoryId: '/ygsjzs/ygnInoutRecord/selectYgnInoutRecordByInventoryId',
  // 分页查询客户出入库列表
  selectYgnInoutRecordByPage: '/ygsjzs/ygnInoutRecord/selectYgnInoutRecordByPage'
}
